import { getSurfaceStore } from 'owa-calendar-surface-surface-store';

export default function isInSplitViewMode(): boolean {
    return getSurfaceStore().isInSplitView;
}
